import StepButtons from "./StepButtons";

const CardMain = ({
    children,
    back = true,
    next = true,
    backText = "INDIETRO",
    nextText = "AVANTI",
    nextDisabled=false,
    nextHandler=null
}) => {
    return <div className="card" >
        <div className="card-body">{children}</div>
        <StepButtons  back={back} next = {next} backText={backText} nextText={nextText} nextDisabled={nextDisabled} nextHandler={nextHandler}/>
    </div>
}
export default CardMain;